module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_maedori_02@2x-2f8087800b92a4f742b3b6768d345821.webp";